import { takeLatest, put, delay, select } from 'redux-saga/effects'
import {
  HANDLE_WS_MESSAGE,
  SET_WEB_RTC_MOUNTED,
  WebSocketMessageActionType,
  RESET_CONNECTION_STATE
} from '../redux/tutorChannelReducer'
import { RootReducer } from '../redux/rootReducer'

function* TimeOutResetConnectionFlow(action: WebSocketMessageActionType): Generator<any, void, any> {
  try {
    if (action.payload?.type === 'connection-state' && action.payload.data === 'connecting') {
      yield delay(5000)
      const connectionState = yield select((state: RootReducer) => state.tutorChannelReducer.connectionState)
      if (connectionState === 'connecting') {
        console.log('resetting connection due to timeout')
        yield put(SET_WEB_RTC_MOUNTED({ value: false }))
        yield put(RESET_CONNECTION_STATE())
        yield delay(1000)
        yield put(SET_WEB_RTC_MOUNTED({ value: true }))
      }
    }
  } catch (error) {
    console.log(error)
  }
}

export default function* TimeOutResetConnectionSaga(): Generator<any, void, any> {
  yield takeLatest([HANDLE_WS_MESSAGE], TimeOutResetConnectionFlow)
}
